class SpatialFeatureClass {
  constructor({
    id,
    slug,
    area_id,
    sports,
    name,
    created_at,
    updated_at,
    archived_at,
    geometry_type,
    audience,
    icon,
    color,
    is_abstract,
    is_global,
    parent_id,
    hierarchy,
    properties,
  }) {
    this.id = id;
    this.slug = slug;
    this.area_id = area_id;
    this.sports = sports;
    this.name = name;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.archived_at = archived_at;
    this.geometry_type = geometry_type;
    this.audience = audience;
    this.icon = icon;
    this.color = color;
    this.is_abstract = is_abstract;
    this.is_global = is_global;
    this.parent_id = parent_id;
    this.hierarchy = hierarchy;
    this.properties = properties;
    // relationships
    this.parent = null;
    this.children = [];
  }

  addChild(child) {
    child.parent = this;
    this.children.push(child);
  }

  getParents() {
    const parents = [];
    let parent = this.parent;
    while (parent) {
      parents.push(parent);
      parent = parent.parent;
    }
    return parents;
  }

  getAllChildren() {
    const children = [];
    const recurse = (feature) => {
      if (feature) {
        children.push(feature);
      }
      feature.children?.forEach(recurse);
    };
    recurse();
    return children;
  }

  toObject() {
    const obj = { ...this };
    delete obj.children;
    delete obj.parent;
    return obj;
  }
}

class SpatialFeatureClassSet {
  constructor() {
    this.spatialFeatureClasses = {};
    this.spatialFeatureClassesById = {};
  }

  add(spatialFeatureClasses) {
    // add all to the index
    spatialFeatureClasses?.forEach((spatialFeatureClass) => {
      this.spatialFeatureClasses[spatialFeatureClass.slug] = spatialFeatureClass;
      this.spatialFeatureClassesById[spatialFeatureClass.id] = spatialFeatureClass;
    });
    // set parent relationships
    spatialFeatureClasses?.forEach((spatialFeatureClass) => {
      if (spatialFeatureClass.parent_id) {
        const parent = this.spatialFeatureClassesById[spatialFeatureClass.parent_id];
        if (parent) {
          spatialFeatureClass.parent = parent;
          parent.addChild(spatialFeatureClass);
        }
      }
    });
  }

  remove(spatialFeatureClasses) {
    spatialFeatureClasses?.forEach((spatialFeatureClass) => {
      // remove from index
      delete this.spatialFeatureClasses[spatialFeatureClass.slug];
      delete this.spatialFeatureClassesById[spatialFeatureClass.id];
      // remove from parent
      if (spatialFeatureClass.parent) {
        spatialFeatureClass.parent.children = spatialFeatureClass.parent.children.filter((child) => child.id !== spatialFeatureClass.id);
      }
    });
  }

  _generateTree(root) {
    const tree = { ...root };
    tree.children = root.children.map(child => this._generateTree(child));
    return tree;
  }

  generateTrees() {
    const trees = [];
    for (let id in this.spatialFeatureClassesById) {
      const spatialFeatureClass = this.spatialFeatureClassesById[id];
      if (!spatialFeatureClass.parent) {
        trees.push(this._generateTree(spatialFeatureClass));
      }
    }
    return trees;
  }

}

// eslint-disable-next-line import/no-anonymous-default-export
export { SpatialFeatureClass, SpatialFeatureClassSet };

